// extracted by mini-css-extract-plugin
export var borderRadius = "_6o-4";
export var large = "_6o-3";
export var logoContainer = "_6o-0";
export var nameLogo = "_6o-2";
export var small = "_6o-1";